(function () {
  if (!window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;

  var EASE = 'cubic-bezier(0.23, 1, 0.32, 1)';

  // Scroll reveal: fade + rise, staggered within a section, once.
  var targets = document.querySelectorAll(
    '.shopify-section:not(:first-child) .kivo-section__inner > :not(.kivo-hero__grid), .kivo-carousel__slide'
  );
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      io.unobserve(el);
      var delay = Math.min(Number(el.dataset.kivoIndex || 0), 5) * 60;
      el.animate(
        [{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'none' }],
        { duration: 600, delay: delay, easing: EASE, fill: 'backwards' }
      );
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  targets.forEach(function (el, i) {
    var siblings = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : i;
    el.dataset.kivoIndex = siblings;
    io.observe(el);
  });

  // Hero: media eases from 1.08 to 1 and the copy lifts and fades as you scroll away.
  var hero = document.querySelector('.kivo-hero--full');
  if (!hero) return;
  var copy = hero.querySelector('.kivo-hero__content');
  var ticking = false;

  function update() {
    ticking = false;
    var p = Math.min(Math.max(window.scrollY / hero.offsetHeight, 0), 1);
    if (copy) {
      copy.style.opacity = (1 - p * 1.3).toFixed(3);
      copy.style.transform = 'translateY(' + (-p * 40).toFixed(1) + 'px)';
    }
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();
